import { observable, action } from "mobx";
import { Orcamento } from "../../../../services";
import { success, error } from "../../../../utils/MensagemUtil";
import * as CsSituacaoOrcamento from "../../../../constantes/CsSituacaoOrcamento";
import * as CsTipoUnidade from "../../../../constantes/CsTipoUnidade";
import * as util from "../../../../utils/MascaraUtil";
import { validarCamposObrigatorios } from "../../../../utils/Validate";

class OrcamentoStore {
  @observable
  orcamento = {
    id: null,
    nome: "",
    descrciao: "",
    titulo: "",
    orgao: "",
    percentualTotalBDI: "",
    percentualLeisSociais: "",
    percentualHoristaComDesoneracao: "",
    percentualMensalistaComDesoneracao: "",
    percentualHoristaSemDesoneracao: "",
    percentualMensalistaSemDesoneracao: "",
    etapas: [],
    csSituacaoOrcamento: {}
  };

  @observable
  fetching = false;

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.orcamento[name] = value;
  };

  @action.bound
  handleBlur = ({ target }) => {
    const { name, value } = target;
    if (value) {
      const valor = util.remover(value);
      const [nome, servico_id, item_id, etapa_id] = name.split("-");

      const etapa = this.orcamento.etapas.find(etapa => etapa.id === parseInt(etapa_id, 0));
      const item = etapa.itens.find(item => item.id === parseInt(item_id, 0));
      const servico = item.servicos.find(servico => servico.id === parseInt(servico_id, 0));

      servico[nome] = valor;

      this.calcularTotaisPlanilha();
    }
  };

  @action.bound
  async obterPlanilhaOrcamento(id) {
    try {
      this.fetching = true;

      const result = await Orcamento.buscarPlanilha(id);
      if (result && result.erro) {
        error(result.erro);
        return;
      }

      this.orcamento = {
        ...result,
        csSituacaoOrcamento: CsSituacaoOrcamento.valueOf(result.situacao)
      };

      this.calcularTotaisPlanilha();
    } finally {
      this.fetching = false;
    }
  }

  calcularTotaisPlanilha = () => {
    this.orcamento.valorTotalGeral = 0;
    this.orcamento.valorTotalGeralSuplan = 0;

    this.orcamento.etapas = this.orcamento.etapas.map(etapa => {
      let valorTotalEtapa = 0;
      let valorTotalEtapaSuplan = 0;

      return {
        ...etapa,
        itens: etapa.itens.map(item => {
          let valorTotalItem = 0;
          let valorTotalItemSuplan = 0;

          return {
            ...item,
            servicos: item.servicos
              ? item.servicos.map(servico => {
                  const valorSubTotal = servico.valorTotalMaterial + servico.valorTotalMaoObra + servico.valorTotalLeisSociais;
                  const valorTotalBDI = parseFloat((servico.percentualBdi * valorSubTotal).toFixed(2) / 100);
                  const valorTotal = valorSubTotal + valorTotalBDI;
                  const valorTotalGeral = parseFloat((valorTotal * (servico.quantidade || 0)).toFixed(2));
                  const valorTotalSuplan = servico.valorSuplan * (servico.quantidade || 0);

                  valorTotalItem += valorTotalGeral;
                  valorTotalItemSuplan += valorTotalSuplan;
                  valorTotalEtapa += valorTotalGeral;
                  valorTotalEtapaSuplan += valorTotalSuplan;

                  this.orcamento.valorTotalGeral += valorTotalGeral;
                  this.orcamento.valorTotalGeralSuplan += valorTotalSuplan;

                  return {
                    ...servico,
                    unidade: CsTipoUnidade.valueOf(servico.tipoUnidade).simbolo,
                    valorTotal: util.moeda(valorTotal),
                    valorTotalSuplan: util.moeda(valorTotalSuplan),
                    valorTotalGeral: util.moeda(valorTotalGeral),
                    quantidade: servico.quantidade || 0
                  };
                })
              : null,
            valorTotalSuplan: valorTotalItemSuplan,
            valorTotal: valorTotalItem
          };
        }),
        valorTotal: valorTotalEtapa,
        valorTotalSuplan: valorTotalEtapaSuplan
      };
    });
  };

  @action.bound
  async avancarCronograma(history) {
    try {
      this.fetching = true;

      const erros = this.validarPlanilhaOrcamento(this.orcamento);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Orcamento.atualizarPlanilha(this.toOrcamento());
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Orçamento atualizado com sucesso!");

      history.push(`/cadastros/orcamentos/cronograma/${this.orcamento.id}`);
    } finally {
      this.fetching = false;
    }
  }

  validarPlanilhaOrcamento = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Nome", registro.nome)
      .addSeNuloOuVazio("Descrição", registro.descricao)
      .addSeNuloOuVazio("Obra", registro.titulo)
      .addSeNuloOuVazio("Órgão", registro.orgao);

    this.orcamento.etapas.forEach(etapa => {
      etapa.itens.forEach(item => {
        if (item.servicos) {
          item.servicos.forEach(servico => {
            if (!servico.quantidade || servico.quantidade <= 0) {
              erros.addMensagem(`A Quantidade de ${servico.nome} deve ser preenchida!`);
            }
          });
        }
      });
    });

    return erros.build();
  };

  toOrcamento() {
    const servicos = [];
    this.orcamento.etapas.forEach(etapa => {
      etapa.itens.forEach(item => {
        if (item.servicos) {
          item.servicos.forEach(servico => {
            servicos.push(servico);
          });
        }
      });
    });

    const novo = {
      ...this.orcamento,
      servicos
    };

    return novo;
  }
}

export default new OrcamentoStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/orcamentos/stores/PlanilhaStore.js